<template>
  <div class>
    <el-form
      :model="dataForm"
      label-position="left"
      label-width="130px"
      :rules="rules"
      ref="dataForm"
    >
      <div class="clearFix top-btn-box">
        <router-link class="floatl" to="/pc/product">＜＜ 去添加商品</router-link>
        <div class="floatr">
          <el-button type="primary" @click="confirmOrder(dataForm)">提交订单</el-button>
        </div>
      </div>
      <el-table
        class="goods-table"
        max-height="400"
        ref="multipleTable"
        :data="goodsTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="productName" label="产品名称" align="center" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column prop="orderNo" label="产品编号" align="center" show-overflow-tooltip width="140"></el-table-column>
        <el-table-column prop="specifications" label="规格" align="center"></el-table-column>
        <el-table-column prop="brandName" label="品牌" align="center"></el-table-column>
        <el-table-column prop="periodValidity" label="有效期(天)" width="140" align="center"></el-table-column>
        <el-table-column prop="packaging" label="主计量单位" width="100" align="center"></el-table-column>
        <el-table-column prop="futures" label="库存状态" width="100" align="center"></el-table-column>
        <el-table-column prop="pyMoney" label="标准价(￥)" width="140" align="center"></el-table-column>
        <el-table-column prop="membersPyMoney" label="会员价(￥)" width="140" align="center"></el-table-column>
        <el-table-column prop="productNumber" label="数量" align="center"></el-table-column>
        <el-table-column prop="endPyMoney" label="金额(￥)" align="center"></el-table-column>
      </el-table>
      <!-- chen start -->
      <el-row class="sum-money-box">
        <el-col class="sum-money" :span="24" v-if="sumMoney==0">
          合计：
          <span class="sum-red"></span> 0 元
        </el-col>
        <el-col class="sum-money" :span="24" v-else>
          合计：
          <span class="sum-red">{{sumMoney}}</span> 元
        </el-col>
      </el-row>
      <!-- end -->
      <div class="div-top-tip">
        商城目前有活动，
        <router-link class="table-tip-link" to></router-link>参与优惠的商品如下：
      </div>
      <div class="sale-table">
        <el-table
          class
          max-height="200"
          ref="multipleTable"
          :data="saleTable"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column prop="orderNo" label="产品货号"></el-table-column>
          <el-table-column prop="promotionCode" label="促销码" >
            <template slot-scope="scope">
              <span :id="'saleCode'+scope.row.promotionCode" class="promotionCode">{{scope.row.promotionCode}}</span>
              <el-button @click="copySaleCode(scope.row)" plain size="mini" class="floatr">点击复制</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="描述">
          </el-table-column>
        </el-table>
        <div class="sale-table-handle">
          <el-input
            v-model="dataForm.saleCode"
            placeholder="请输入您要参与的促销码"
            clearable
            @change="change"
          ></el-input>
          <i class="el-icon-info">您只能输入一个促销码</i>
        </div>
      </div>
      <div class="div-top-tip">请填写合同编号</div>
      <div class="contractNo">
        <el-form-item label="合同编号" label-width="80px" prop="contractNo">
          <el-input v-model="addressInfoVo.contractNo" clearable></el-input>
        </el-form-item>
      </div>
      <div class="contractNo">
        <el-form-item label="备注" label-width="80px" prop="note">
          <el-input v-model="addressInfoVo.note" clearable></el-input>
        </el-form-item>
      </div>
      <div class="div-top-tip">
        请填写邮寄地址
        <el-button type="text" style="height: 15px;" size="small" @click="resetPassWord()">选择收货地址</el-button>
      </div>

      <div class="register-input-box">
        <el-form-item label="省市" prop="province">
          <el-cascader
            expand-trigger="hover"
            :options="provinceOptions"
            v-model="dataForm.province"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label prop="addressDetail" class="addressDetail">
          <el-input v-model="dataForm.addressDetail" placeholder="详细地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人" prop="contact">
          <el-input v-model="dataForm.contact" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人联系方式" prop="contactMobilePhone">
          <el-input v-model.number="dataForm.contactMobilePhone" maxlength="11" clearable></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoiceTitle">
          <el-input autosize v-model="dataForm.invoiceTitle" clearable></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="invoiceNumber">
          <el-input autosize v-model="dataForm.invoiceNumber" clearable></el-input>
        </el-form-item>
      </div>
    
    </el-form>
    <el-dialog
      title="我的收货地址"
      :visible.sync="isResetPassword"
      :modal="false"
      width="420px"
      @close="close"
    >
    <el-button type="text" size="small" style=" margin-top: -12%;"  @click="addressmods()" >添加新的收货地址</el-button>
      <el-row v-for="(item, index) of address" :key="index" style="width: 100%">
        <el-col style="float: left; width: 50%;">
          <div style="margin: 10px;height: 18px;">
            <span class="span">{{item.status == 2 ? '默认' : ''}}</span>
            <span class="span1">{{item.goodsUser}}</span>&nbsp;&nbsp;
            <span class="span2">{{item.phoneNumber}}</span>
          </div>
          <div class="div001">{{item.provinceCity}}{{item.location}}</div>
        </el-col>
        <el-col style="float: left; width: 50%;">
          <el-button
            type="text"
            size="small"
            style="float: left;min-width: 39px;"
            @click="updateressmod(item)"
          >编辑</el-button>
          <el-button
            type="text"
            size="small"
            style="float: left;min-width: 39px;"
            @click="deletes(item)"
          >删除</el-button>
          <el-button
            type="text"
            size="small"
            style="float: left;min-width: 39px;"
            @click="application(item)"
          >应用</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="收货地址"
      :visible.sync="isAddressmodification"
      :modal="false"
      width="400px"
      @close="close1"
    >
      <el-form :model="addressInfoVo" ref="addressInfoVo">
        <el-form-item label="省市" prop="province" label-width="80px">
          <el-cascader
            expand-trigger="hover"
            ref="areaSelect"
            :options="provinceaa"
            @change="handleChange"
            v-model="addressInfoVo.province"
            clearable
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="具体位置" label-width="80px" prop="location">
          <el-input v-model="addressInfoVo.location" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人" label-width="80px" prop="goodsUser">
          <el-input v-model="addressInfoVo.goodsUser" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系方式" label-width="80px" prop="phoneNumber">
          <el-input v-model="addressInfoVo.phoneNumber" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" label-width="80px" prop="lookupName">
          <el-input v-model="addressInfoVo.lookupName" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="识别号" label-width="80px" prop="taxpayersIdentificationNumber">
          <el-input
            v-model="addressInfoVo.taxpayersIdentificationNumber"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="默认地址" label-width="80px" prop="status">
          <el-switch v-model="status" @change="ModifyStatus"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-radio
            v-model="addressInfoVo.radio"
            v-if="addressInfoVo.id && addressInfoVo.radio ==1"
            label="1"
            class="label01"
          >增值税专用发票</el-radio>
          <el-radio
            v-model="addressInfoVo.radio"
            v-if="addressInfoVo.id && addressInfoVo.radio ==2"
            label="2"
          >增值税普通发票</el-radio>
          <el-radio v-model="radio" v-if="addressInfoVo.id ==''" label="1" class="label01" >增值税专用发票</el-radio>
          <el-radio v-model="radio" v-if="addressInfoVo.id == ''" label="2">增值税普通发票</el-radio>
        </el-form-item>
        <el-form-item class="form-itemis">
          <div class="register-inputs" v-if="radio==1">
            <el-form
              :model="addressInfoVo"
              label-position="left"
              ref="addressInfoVo"
              label-width="120px"
              class="dataformss"
            >
              <el-form-item label="单位名称" prop="unitName" label-width="80px">
                <el-input v-model="addressInfoVo.unitName" clearable style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item label="账号" prop="account" label-width="80px">
                <el-input v-model="addressInfoVo.account" clearable style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item label="开户行" prop="openAccount" label-width="80px">
                <el-input v-model="addressInfoVo.openAccount" clearable style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address" label-width="80px">
                <el-input v-model="addressInfoVo.address" clearable style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone" label-width="80px">
                <el-input v-model="addressInfoVo.phone" clearable></el-input>
              </el-form-item>
              <el-form-item label="税号" prop="ein" label-width="80px">
                <el-input v-model="addressInfoVo.ein" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="register-inputs" v-if="radio==2">
            <el-form
              :model="addressInfoVo"
              label-position="left"
              :rules="rules"
              ref="addressInfoVo"
              label-width="120px"
              class="dataform-input-box"
            >
              <el-form-item label="单位名称" prop="unitName" label-width="80px">
                <el-input v-model="addressInfoVo.unitName" clearable></el-input>
              </el-form-item>
              <el-form-item label="税号" prop="ein" label-width="80px">
                <el-input v-model="addressInfoVo.ein" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetform">取 消</el-button>
        <el-button type="primary" @click="submitModification">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post, get, postRequest, newpostRequest } from "@/axios/index";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  data() {
    // 验证手机号
    const ruleTel = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
    const checkTel = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("手机号为空"));
      } else if (!ruleTel.test(value)) {
        return callback(new Error("请确认手机格式是否正确"));
      } else {
        get("/stkuserregisterinfo/getbyphonenumber", {
          phoneNumber: value
        }).then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.telFlag = true;
            callback();
          } else {
            return callback(new Error(res.data.msg));
          }
        });
      }
    };
    // 验证合同编号
    const ruleTels = /^[0-9a-zA-Z]+$/;
    const checkTelaaas = (rule, value, callback) => {
      console.log(value);
      if (value == "") {
        return callback(new Error("合同编号为空"));
      } else if (!ruleTels.test(value)) {
        return callback(new Error("请确认手机格式是否正确"));
      }
    };
    return {
      isResetPassword: false, // 是否打开选择地址对话框
      isAddressmodification: false, // 是否打开选择地址对话框
      addressaa: {},
      address: [], //地址列表
      proCity: [],
      provinceCity: [],
      userRegister: [],
      status: true,
      copyDate:'',
      stkProductId:'',
      addressInfoVo: {
        id: "",
        userRegisterId: "", //用户id
        provinceCity: "", //省市
        provinceCitys: "", //省市
        provinces: "",
        province: [],
        location: "", //详细地址
        goodsUser: "", //收货人
        phoneNumber: "", //联系方式
        lookupName: "", //抬头名称
        taxpayersIdentificationNumber: "", //纳税人识别号
        status: "1", //是否是默认地址
        radio: "", //增值税类型
        unitName: "", //单位名称
        account: "", //账号`
        openAccount: "", //开户行
        address: "", //地址
        phone: "", //电话
        ein: "", //税号
        contractNo: "",
        copyDate:'',
        stkProductId:'',
        note:''
      },
      aaa: "",
      radio: "", //增值税专用发票和普通发票
      code: "",
      //合同路径
      agreementUrl: "./style/img/contract.jpg",
      //省市数据
      provinceOptions: regionData,
      provinceaa: regionData,
      //表单数据
      dataForm: {
        //详细地址
        addressDetail: "",
        //省市选中值
        province: [],
        //收货人姓名
        contact: "",
        //收货人电话
        contactMobilePhone: "",
        //发票抬头
        invoiceTitle: "",
        //纳税人识别号
        invoiceNumber: "",
        //促销码
        saleCode: ""
      },
      //购物车商品数据
      goodsTable: [],
      //输入促销码改变商品数据
      membersMoney: [],
      membersney: [],
      //优惠信息表格
      saleTable: [],
      //输入促销码改变总金额
      saleTablesa: {
        specialRules: "",
        productId: "",
        listingPrice: "",
        listingNumber: ""
      },
      saleTablesag: [],
      goodsTable01: {
        productNumber: 0,
        endPyMoney: "",
        specialRules: "",
        listingPrice: "",
        listingNumber: ""
      },
      goodsTable010: [],
      goodsTable011: [],
      goodsTablesaa: [
        {
          productNumber: 0,
          endPyMoney: ""
        }
      ],
      goodsTable02: {
        productNumber: 0,
        endPyMoney: ""
      },
      //规则
      rules: {
        province: [
          {
            required: true,
            message: "请选择省市",
            trigger: "change"
          }
        ],
        addressDetail: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }
        ],
        contact: [
          {
            required: true,
            message: "请输入收货人",
            trigger: "blur"
          }
        ],
        contactMobilePhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            type: "number",
            message: "联系电话必须为数字值"
          }
        ],
        invoiceTitle: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur"
          }
        ],
        invoiceNumber: [
          {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur"
          }
        ],
        location: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }
        ],
        goodsUser: [
          {
            required: true,
            message: "请输入收货人名称",
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {
            required: true,
            // message: "请输入手机号码",
            validator: checkTel,
            trigger: ["blur"]
          }
        ],
        contractNo: [
          {
            required: true,
            // message: "请输入手机号码",
            validator: checkTelaaas,
            trigger: ["blur"]
          }
        ],
        lookupName: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: "blur"
          }
        ],
        taxpayersIdentificationNumber: [
          {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur"
          }
        ]
      },
      // chen
      sumMoney: 0,
      userRId: 0,
      codeDate: {}
    };
  },
  methods: {
    createPerson(id, goodsPrice, productId, shoppingId) {
      //1、原料
      var obj = new Object();
      //2、加工
      obj.productId = id;
      obj.goodsPrice = goodsPrice;
      obj.goodsNumber = productId;
      obj.shoppingId = shoppingId;

       console.log("obj529========",obj)
      //3、出场
      return obj;
    },
    createPersonTwo(
      userRegisterId,
      promotionCode,
      unitLocation, //详细地址
      unitProvinceCity, //省市
      unitProvinceCitys, //省市
      contactUser, //姓名
      promotionId, //促销id
      productId, //产品id
      phoneNumber, //手机号
      lookupName,
      taxpayersIdentificationNumber,
      contractNo,
      copyDate,
      stkProductId,
      note
    ) {
      //1、原料
      var obj = new Object();
      //2、加工
      obj.userRegisterId = userRegisterId;
      obj.promotionCode = promotionCode;
      obj.unitLocation = unitLocation;
      obj.unitProvinceCity = unitProvinceCity;
      obj.unitProvinceCitys = unitProvinceCitys;
      obj.contactUser = contactUser;
      obj.promotionId = promotionId;
      obj.productId = productId;
      obj.phoneNumber = phoneNumber;
      obj.lookupName = lookupName;
      obj.taxpayersIdentificationNumber = taxpayersIdentificationNumber;
      obj.contractNo = contractNo;
      obj.copyDate = copyDate;
      obj.stkProductId = stkProductId;
      obj.note = note;
      //3、出场
      return obj;
    },
    //提交订单
    confirmOrder(dataForm) {
      if (!this.addressInfoVo.contractNo) {
        this.$message({
          message: "请输入合同编号",
          type: "error"
        });
        return;
      }
      if (
        this.dataForm.addressDetail == "" ||
        this.dataForm.contact == "" ||
        this.dataForm.contactMobilePhone == "" ||
        this.dataForm.invoiceNumber == "" ||
        this.dataForm.invoiceTitle == "" ||
        this.dataForm.province.length == 0
      ) {
        this.$message({
          type: "warning",
          message: "请确认邮寄地址信息是否都照实填写"
        });
      } else {
        let arrObj = [];
        // this.membersMoney = JSON.parse(
        //   JSON.stringify(JSON.parse(localStorage.getItem("loc")))
        // );
        console.log("dataForm========",dataForm)
        console.log("603",this.goodsTable)
        // this.goodsTable = this.membersMoney;
        // 点击提交订单
        this.goodsTable.forEach(ele => {
          arrObj.push(
            this.createPerson(
              ele.productId,
              ele.membersPyMoney,
              ele.productNumber,
              ele.id
            )
          );
        });
        let add = "";
        let adds = "";
        adds = dataForm.province.join(",");
        console.log(dataForm.province);
        dataForm.province.forEach(ele => {
          add += CodeToText[ele];
        });
        arrObj.push(
          this.createPersonTwo(
            this.userRId,
            this.dataForm.saleCode,
            this.dataForm.addressDetail,
            add,
            adds,
            this.dataForm.contact,
            this.codeDate.promotionId,
            this.codeDate.productId,
            this.dataForm.contactMobilePhone,
            this.dataForm.invoiceTitle,
            this.dataForm.invoiceNumber,
            this.addressInfoVo.contractNo,
            this.copyDate,
            this.stkProductId,
            this.addressInfoVo.note
          )
        );
        this.createPersonTwo(
          this.userRId,
          this.dataForm.saleCode,
          this.dataForm.addressDetail,
          add,
          adds,
          this.dataForm.contact,
          this.codeDate.promotionId,
          this.codeDate.productId,
          this.dataForm.contactMobilePhone,
          this.dataForm.invoiceTitle,
          this.dataForm.invoiceNumber,
          this.addressInfoVo.contractNo,
          this.copyDate,
          this.stkProductId,
          this.addressInfoVo.note
        );
        console.log("arrObj----------", arrObj);
        let promot = {};
        arrObj.map(item => {
          if (item.promotionId) {
            promot.promotionId = item.promotionId;
            promot.promotionCode = item.promotionCode;
          }
        });
        let sale = {};
        console.log(this.saleTable);
        console.log(promot);
        if(this.saleTable != null){
          this.saleTable.map(item => {
            if (item.promotionId == promot.promotionId) {
              if (item.promotionCode == promot.promotionCode) {
                sale = item;
              }
            }
        });
        }
        console.log(sale);
        if (sale) {
          this.$message({
            type: "success",
            message: "促销码符合要求!"
          });
        }
        console.log('674',arrObj)
        // return
        postRequest("/stkorderinfo/insertstkorderinfo", arrObj).then(res => {
          if (res.data.code == 200) {
            localStorage.removeItem("loc");
            this.goodsTable = [];
            this.sumMoney = 0;
            this.$router.push({
              path: "/pc/order-detail",
              query: {
                id: res.data.result,
                userRID: this.userRId
              }
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      }
    },
    //下载图片
    downloadImg(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    //复制促销码
    copySaleCode(data) {
      this.copyDate = JSON.stringify(data)
      this.codeDate = data;
      let value = "saleCode" + data.promotionCode;
      const span = document.getElementById(value);
      this.code = value;
      window.getSelection().selectAllChildren(span);
      document.execCommand("Copy");
      this.$message({
        type: "success",
        message: "已复制!"
      });
    },
    //点击重置收货地址
    async resetPassWord() {
      this.isResetPassword = true;
      console.log(this.$route.query.userRegId);
      // return
      try {
        const {
          data: { result: res }
        } = await get("/stkaddressinfo/getlistbystatus", {
          userRegisterId: this.$route.query.userRegId
        });
        const {
          data: { result: res1 }
        } = await get("/stkuserregisterinfo/getbyid", {
          id: this.$route.query.userRegId
        });
       
        if (res.length != 0) {
          this.address = res;
        }
        if (res.length == 0) {
          // this.userRegister = res1;
          this.addressaa.goodsUser = res1.userName;
          this.addressaa.phoneNumber = res1.phoneNumber;
          this.addressaa.provinceCitys = res1.unitProvinceCity;
          let city = res1.unitProvinceCity.split(",");
          this.addressaa.provinceCity = `${CodeToText[city[0]]}${
            CodeToText[city[1]]
          }`;
          this.addressaa.location = res1.unitLocation;
          this.addressaa.status = "2";
          this.addressaa.update = "1";
          this.addressaa.radio = res1.radio; //增值税类型
          this.addressaa.unitName = res1.unitName; //单位名称
          this.addressaa.account = res1.account; //账号`
          this.addressaa.openAccount = res1.openAccount; //开户行
          this.addressaa.address = res1.address; //地址
          this.addressaa.phone = res1.phone; //电话
          this.addressaa.ein = res1.ein; //税号

          console.log(this.addressaa);
          let ass = [];
          ass.push(this.addressaa);
          this.address = ass;
          console.log(this.address);
        }
      } catch (error) {}
       console.log('771',this.address);
    },
    //点击编辑收货地址
    async updateressmod(data) {
       console.log('775',data);
      this.isResetPassword = false;
      this.isAddressmodification = true;
      if(!data.radio){
        this.addressInfoVo.radio == '1'
      }
      this.addressInfoVo = data;
      
      console.log('782',this.addressInfoVo.radio);
      this.status = this.addressInfoVo.status == 2 ? true : false;
      this.radio = this.addressInfoVo.radio; //增值税类型
      if (data.update) {
        console.log("11111==========");
        this.addressInfoVo.province = data.provinceCitys.split(",");
        console.log("11111==========" + this.addressInfoVo.province);
      }
      if (!data.update) {
        this.addressInfoVo.province = data.provinceCitys.split(",");
      }
      console.log('806',data);
    },
    //添加地址
    async addressmods() {
      this.isResetPassword = false;
      this.isAddressmodification = true;
      this.radio = '2';
      this.addressInfoVo.status = 2;
      console.log('812',this.addressInfoVo)
    },
    //默认地址滑块
    ModifyStatus() {
      this.addressInfoVo.status = this.status == true ? 2 : 1;
      console.log(this.addressInfoVo.status);
    },
    //关闭重置表单对话框
    close() {
      this.address = {}; //
      this.isResetPassword = false;
    },
    //关闭重置编辑地址对话框
    close1() {
        this.addressInfoVo.id = "";
        this.addressInfoVo.userRegisterId= "";//用户id
        this.addressInfoVo.provinceCity= ""; //省市
        this.addressInfoVo.provinceCitys= []; //省市
        this.addressInfoVo.provinces= "";
        this.addressInfoVo.province= [];
        this.addressInfoVo.location= ""; //详细地址
        this.addressInfoVo.goodsUser= ""; //收货人
        this.addressInfoVo.phoneNumber= ""; //联系方式
        this.addressInfoVo.lookupName= ""; //抬头名称
        this.addressInfoVo.taxpayersIdentificationNumber= ""; //纳税人识别号
        this.addressInfoVo.status= ""; //是否是默认地址
        this.addressInfoVo.radio= ""; //增值税类型
        this.addressInfoVo.unitName= ""; //单位名称
        this.addressInfoVo.account= ""; //账号`
        this.addressInfoVo.openAccount= ""; //开户行
        this.addressInfoVo.address= ""; //地址
        this.addressInfoVo.phone= ""; //电话
        this.addressInfoVo.ein= ""; //税号
        (this.isAddressmodification = false);
      this.resetPassWord();
    },
    // 关闭重置编辑地址对话框
    resetform() {
       this.addressInfoVo.id = "";
        this.addressInfoVo.userRegisterId= "";//用户id
        this.addressInfoVo.provinceCity= ""; //省市
        this.addressInfoVo.provinceCitys= []; //省市
        this.addressInfoVo.provinces= "";
        this.addressInfoVo.province= [];
        this.addressInfoVo.location= ""; //详细地址
        this.addressInfoVo.goodsUser= ""; //收货人
        this.addressInfoVo.phoneNumber= ""; //联系方式
        this.addressInfoVo.lookupName= ""; //抬头名称
        this.addressInfoVo.taxpayersIdentificationNumber= ""; //纳税人识别号
        this.addressInfoVo.status= ""; //是否是默认地址
        this.addressInfoVo.radio= ""; //增值税类型
        this.addressInfoVo.unitName= ""; //单位名称
        this.addressInfoVo.account= ""; //账号`
        this.addressInfoVo.openAccount= ""; //开户行
        this.addressInfoVo.address= ""; //地址
        this.addressInfoVo.phone= ""; //电话
        this.addressInfoVo.ein= ""; //税号
        (this.isAddressmodification = false);
      this.resetPassWord();
    },
    /**
     * @description 省市二级联动选择
     */
    handleChange(value) {
      console.log("575", value);
      var areaName = this.$refs["areaSelect"].currentLabels;
      this.addressInfoVo.provinces = areaName;
      console.log(areaName);
    },
    // 提交修改内容
    async submitModification(data) {
      console.log(data.provinceCity);
      (this.addressInfoVo.userRegisterId = this.$route.query.userRegId), //用户id
        (this.addressInfoVo.provinceCity = this.addressInfoVo.provinces
          ? this.addressInfoVo.provinces.join("")
          : this.addressInfoVo.provinceCity);
      this.addressInfoVo.provinceCitys = this.addressInfoVo.province
        ? this.addressInfoVo.province.join(",")
        : [];
      console.log(this.addressInfoVo);
      if (this.addressInfoVo.province.length == 0) {
        return this.$message({
          type: "error",
          message: "请输入省市"
        });
      }
      if (!this.addressInfoVo.location) {
        return this.$message({
          type: "error",
          message: "请输入详细地址"
        });
      }
      if (!this.addressInfoVo.goodsUser) {
        return this.$message({
          type: "error",
          message: "请输入收货人名称"
        });
      }
      if (!this.addressInfoVo.phoneNumber) {
        return this.$message({
          type: "error",
          message: "请输入联系方式"
        });
      }
      if (!this.addressInfoVo.lookupName) {
        return this.$message({
          type: "error",
          message: "请输入抬头名称"
        });
      }
      if (!this.addressInfoVo.taxpayersIdentificationNumber) {
        return this.$message({
          type: "error",
          message: "请输入纳税人识别号"
        });
      }
      if (this.radio == 2) {
        if (!this.addressInfoVo.unitName) {
          return this.$message({
            type: "error",
            message: "请输入单位名称"
          });
        }
        if (!this.addressInfoVo.ein) {
          return this.$message({
            type: "error",
            message: "请输入税号"
          });
        }
      } else {
        if (!this.addressInfoVo.unitName) {
          return this.$message({
            type: "error",
            message: "请输入单位名称"
          });
        }
        if (!this.addressInfoVo.account) {
          return this.$message({
            type: "error",
            message: "请输入账号"
          });
        }
        if (!this.addressInfoVo.openAccount) {
          return this.$message({
            type: "error",
            message: "请输入开户行"
          });
        }
        if (!this.addressInfoVo.address) {
          return this.$message({
            type: "error",
            message: "请输入地址"
          });
        }
        if (!this.addressInfoVo.phone) {
          return this.$message({
            type: "error",
            message: "请输入电话"
          });
        }
        if (!this.addressInfoVo.ein) {
          return this.$message({
            type: "error",
            message: "请输入税号"
          });
        }
      }
      this.addressInfoVo.radio= this.radio;
      console.log(this.addressInfoVo);
      // return;
      if (this.addressInfoVo.id) {
        delete this.addressInfoVo.province;
        try {
          console.log(this.addressInfoVo);
          const {
            data: { result: res }
          } = await postRequest(
            "/stkaddressinfo/updateaddress",
            this.addressInfoVo
          );
          console.log(res);
          this.isResetPassword = false;
          this.isAddressmodification = false;
          // window.location.reload();
        } catch (error) {}
      }
      if (!this.addressInfoVo.id) {
        try {
          const {
            data: { result: res }
          } = await postRequest(
            "/stkaddressinfo/insertstkaddressinfo",
            this.addressInfoVo
          );
          console.log(res);
          this.isResetPassword = false;
          this.isAddressmodification = false;
          // window.location.reload();
        } catch (error) {}
      }

      // return
    },
    //删除地址
    async deletes(data) {
      try {
        const isTrue = await this.$confirm(
          "此操作将永久删除地址信息, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        console.log('1025',data);
        this.id = data.id;
        const {
          data: { result: res }
        } = await get("/stkaddressinfo/delectbyidandstatus", { id: this.id });
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        window.location.reload();
      } catch (error) {
        if (error === "cancel") {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        }
      }
    },
   async application(data) {
      console.log('1054',data);
      this.dataForm.addressDetail = data.location;
      this.dataForm.province = data.provinceCitys.split(",");
      this.dataForm.contact = data.goodsUser;
      this.dataForm.contactMobilePhone = Number(data.phoneNumber);
       this.dataForm.invoiceTitle = data.lookupName; //抬头名称
      this.dataForm.invoiceNumber = data.taxpayersIdentificationNumber; //纳税人识别号
      this.close();
      console.log('1054',data);
    },
    //输入促销码改变总金额
    async change(data) {
      if (this.dataForm.saleCode) {
        const {
          data: { result: res }
        } = await get("/stkpromotioninfo/getlistbyshoppingcenter", {
          userRegisterId: this.$route.query.userRegId
        });
        let aleys=[];
      this.goodsTable.forEach(items1 => {
        res.forEach(item=> {
          if (items1.productId == item.productId) {
            aleys.push(item);
          }
        });
      });
        let productIds = {};
        let goodsTables = {};
        let goodsTablesaa = [];
        this.saleTablesag = [];
        let Tablesaa = {};
        let aaass = ""; //总金额
        let aaass01 = ""; //起订量
        this.Tablesaa = this.goodsTable.map((item, index) => {
          if (this.codeDate.productId == item.productId) {
            this.aaass = item.endPyMoney;
            this.aaass01 = item.productNumber;
            return item;
          }
        });
        let mayty = this.aaass * this.aaass01;
        this.productIds = aleys.map((item, index) => {
          if (this.codeDate.promotionCode == item.promotionCode) {
            if (item.amountAchieved) {
              if (item.amountAchieved <= mayty) {
                if (this.dataForm.saleCode == item.promotionCode) {
                  this.saleTablesa.specialRules = item.specialRules;
                  this.saleTablesa.productId = item.productId;
                  this.saleTablesag.push(item);
                  return item;
                }
              }
            } else if (item.describtion) {
              if (item.describtion <= this.aaass01) {
                if (this.dataForm.saleCode == item.promotionCode) {
                  this.saleTablesa.specialRules = item.specialRules;
                  this.saleTablesa.productId = item.productId;
                  this.saleTablesag.push(item);
                  return item;
                }
              }
            } else if (item.listingPrice) {
              if (this.dataForm.saleCode == item.promotionCode) {
                this.saleTablesa.listingNumber = item.listingNumber;
                this.saleTablesa.listingPrice = item.listingPrice;
                this.saleTablesa.productId = item.productId;
                this.saleTablesag.push(item);
                return item;
              }
            }
          }
        });
       
        if (this.saleTablesag.length != 0) {
          this.goodsTable010 = [];
          this.goodsTable011 = [];
          this.saleTablesag.map(items => {
            if (this.saleTablesa.specialRules) {
              this.goodsTables = this.goodsTable.map((item, index) => {
                if (items.productId == item.productId) {
                  let aaam = {
                    productNumber: item.productNumber,
                    endPyMoney: item.pyMoney,
                    specialRules: items.specialRules,
                    productId: items.productId
                  };
                  this.goodsTable010.push(aaam);
                  this.goodsTable011.push(aaam);
                  return item;
                }
              });
            }
            if (items.listingPrice) {
              this.goodsTables = this.goodsTable.map((item, index) => {
                if (items.productId == item.productId) {
                  this.goodsTable01.productNumber = item.productNumber;
                  this.goodsTable01.endPyMoney = item.pyMoney;
                  this.goodsTable01.listingNumber = items.listingNumber;
                  this.goodsTable01.listingPrice = items.listingPrice;
                  this.goodsTable01.specialRules = items.specialRules;
                  let aaam = {
                    productNumber: item.productNumber,
                    endPyMoney: item.endPyMoney,
                    listingNumber: items.listingNumber,
                    listingPrice: items.listingPrice,
                    specialRules: items.specialRules,
                    productId: items.productId
                  };
                  this.goodsTable010.push(aaam);
                  this.goodsTable011.push(aaam);
                  return item;
                }
              });
              console.log(items)
            }
          });
          this.sumMoney = 0;

          this.membersney = [];
          this.membersney = JSON.parse(
            JSON.stringify(JSON.parse(localStorage.getItem("loc")))
          );
          console.log(this.membersney);
          console.log(this.goodsTable011);
          this.goodsTable011.forEach(items => {
            this.membersney.forEach((ele, index0) => {
              if (ele.productId == items.productId) {
                this.membersney.splice(index0, 1);
              }
            });
          });
          console.log(this.membersney);
          console.log(this.sumMoney);
          this.membersney.forEach(ele => {
            if (ele) {
              this.sumMoney += ele.productNumber * ele.membersPyMoney;
              console.log(this.dataForm.saleCode);
            }
          });
          console.log(this.sumMoney);
          console.log('1185',this.goodsTable010);
           this.stkProductId = JSON.stringify(this.goodsTable010);
          this.goodsTable010.forEach(ele => {
            if (ele.productNumber >= ele.listingNumber) {
              this.sumMoney += ele.productNumber * ele.listingPrice;
              this.goodsTable.map(item => {
                if (item.productId == ele.productId) { 
                  item.membersPyMoney = ele.listingPrice.toFixed(2);
                  item.endPyMoney = (ele.listingPrice * item.productNumber).toFixed(2);
                  return item;
                }
              });
            }
            if (ele.specialRules) {
              let special = ele.specialRules / 100;
              this.sumMoney += ele.productNumber * ele.endPyMoney * special;
              this.goodsTable.map(item => {
                if (item.productId == ele.productId) {
                  let mabe = ele.endPyMoney * special;
                  item.membersPyMoney = mabe.toFixed(2);
                  item.endPyMoney = (mabe * item.productNumber).toFixed(2);
                  return item;
                }
              });
            }
          });
          console.log(this.sumMoney);
          this.sumMoney = this.sumMoney.toFixed(2);
          var b = JSON.stringify(this.saleTablesag) == "[]";
          if (b) {
            this.sumMoney = 0;
            console.log(this.membersMoney);
            this.goodsTable011 = [];
            this.goodsTable010 = [];
            this.saleTablesag = [];
            this.saleTablesa = {};
            this.goodsTable01 = {};
            this.goodsTable = [];
            this.goodsTablesaa.length = 0;
            this.membersMoney = JSON.parse(
              JSON.stringify(JSON.parse(localStorage.getItem("loc")))
            );
            this.goodsTable = this.membersMoney;
            this.membersMoney.forEach(ele => {
              this.sumMoney += ele.productNumber * ele.membersPyMoney;
              console.log(this.dataForm.saleCode);
            });
            this.sumMoney = this.sumMoney.toFixed(2);
            if (!this.saleTablesa.specialRules) {
              this.sumMoney = 0;
              console.log(this.membersMoney);
              this.goodsTable011 = [];
              this.goodsTable010 = [];
              this.saleTablesag = [];
              this.saleTablesa = {};
              this.goodsTable01 = {};
              this.goodsTable = [];
              this.membersMoney = JSON.parse(
                JSON.stringify(JSON.parse(localStorage.getItem("loc")))
              );
              this.goodsTable = this.membersMoney;
              this.goodsTablesaa.length = 0;
              this.membersMoney.forEach(ele => {
                this.sumMoney += ele.productNumber * ele.membersPyMoney;
                console.log(this.dataForm.saleCode);
              });
              this.sumMoney = this.sumMoney.toFixed(2);
            }
          }
          this.saleTablesa = {};
          this.goodsTable01 = {};
          this.goodsTablesaa.length = 0;
        }
        if (this.saleTablesag.length == 0) {
          console.log(this.membersMoney);
          this.sumMoney = 0;
          this.saleTablesa = {};
          this.goodsTable01 = {};
          this.goodsTable010 = [];
          this.saleTablesag = [];
          this.goodsTable = [];
          this.goodsTablesaa.length = 0;
          this.membersMoney = JSON.parse(
            JSON.stringify(JSON.parse(localStorage.getItem("loc")))
          );
          this.goodsTable = this.membersMoney;
          this.membersMoney.forEach(ele => {
            this.sumMoney += ele.productNumber * ele.membersPyMoney;
          });
          this.sumMoney = this.sumMoney.toFixed(2);
        }
      }
      if (!this.dataForm.saleCode) {
        console.log(this.membersMoney);
        this.sumMoney = 0;
        this.saleTablesa = {};
        this.goodsTable01 = {};
        this.goodsTable010 = [];
        this.saleTablesag = [];
        this.goodsTable = [];
        this.goodsTablesaa.length = 0;
        this.membersMoney = JSON.parse(
          JSON.stringify(JSON.parse(localStorage.getItem("loc")))
        );
        this.membersMoney.forEach(element => {
          element.membersPyMoney =element.membersPyMoney.toFixed(2)
          element.endPyMoney =(element.productNumber * element.membersPyMoney).toFixed(2)
        });
        console.log('1282',this.membersMoney)
        this.goodsTable = this.membersMoney;
        this.membersMoney.forEach(ele => {
          this.sumMoney += ele.productNumber * ele.membersPyMoney;
        });
        this.sumMoney = this.sumMoney.toFixed(2);
      }
    }
  },
  async created() {
    localStorage.setItem("chen", "one");
    this.goodsTable = JSON.parse(localStorage.getItem("loc")); 
    this.goodsTable.forEach(element => {
      element.membersPyMoney =element.membersPyMoney.toFixed(2)
      element.endPyMoney =(element.productNumber * element.membersPyMoney).toFixed(2)
    });
    console.log("this.goodsTable----------------", this.goodsTable);
    this.membersMoney = JSON.parse(
      JSON.stringify(this.goodsTable)
    );
    this.membersney = JSON.parse(
      JSON.stringify(this.goodsTable)
    );
    this.userRId = JSON.parse(localStorage.getItem("stkMessage")).id;
    this.goodsTable.forEach(ele => {
      this.sumMoney += ele.productNumber * ele.membersPyMoney;
      console.log(this.dataForm.saleCode);
    });
    this.sumMoney = this.sumMoney.toFixed(2);
    get("/stkpromotioninfo/getlistbyshoppingcenter", {
      userRegisterId: this.userRId
    }).then(res => {
      console.log("促销列表res------", res.data.result);
      let aley=[];
      this.goodsTable.forEach(items1 => {
        res.data.result.forEach(item=> {
          if (items1.productId == item.productId) {
            console.log("---1330---", items1.endPyMoney , items1.productNumber);
            console.log("---1331---", item.amountAchieved,item.describtion,item.listingNumber);
            if ( item.amountAchieved != 0 && item.amountAchieved >= items1.endPyMoney * items1.productNumber) {
              aley.push(item);
              console.log("---1---");
            }else if ( item.describtion && items1.productNumber  >= item.describtion) {
              aley.push(item);
               console.log("---2---");
            }else if(items1.productNumber  >= item.listingNumber){
              aley.push(item);
               console.log("---3---");
            }
          }
        });
      });
       this.saleTable = aley.map((item, index)=>{
          if (item.specialRules) {
              if (item.specialRules.substring(1) == "0") {
                item.specialRules = item.specialRules.substr(0, 1);
                return item;
              }
              return item;
            }
            if (!item.specialRules) {
              if(item.listingPrice){
              return item;
              }
            }
      })
      console.log(this.saleTable)
    });
    //请求注册时收货地址等信息
    const {
      data: { result: res }
    } = await get("/stkaddressinfo/getlistbystatus", {
      userRegisterId: this.userRId
    });
    if (res.length != 0) {
      if (res.length == 1) {
        let getlist = {};
        this.getlist = res.map((item, index) => {
          this.dataForm.addressDetail = item.location;
          this.dataForm.province = item.provinceCitys.split(",");
          this.dataForm.contact = item.goodsUser;
          this.dataForm.contactMobilePhone = Number(item.phoneNumber);
          this.dataForm.invoiceTitle = item.lookupName;
          this.dataForm.invoiceNumber = item.taxpayersIdentificationNumber;
          return item;
        });
      }
      if (res.length > 1) {
        let getlist = {};
        this.getlist = res.map((item, index) => {
          if (item.status == 2) {
            this.dataForm.addressDetail = item.location;
            this.dataForm.province = item.provinceCitys.split(",");
            this.dataForm.contact = item.goodsUser;
            this.dataForm.contactMobilePhone = Number(item.phoneNumber);
            this.dataForm.invoiceTitle = item.lookupName;
            this.dataForm.invoiceNumber = item.taxpayersIdentificationNumber;
            return item;
          }
        });
      }
      console.log('1391',this.dataForm)
    }
    if (res.length == 0) {
      get("/stkuserregisterinfo/getbyid", {
        id: this.userRId
      }).then(res => {
        let defaultMsg = res.data.result;
        this.dataForm.addressDetail = defaultMsg.unitLocation;
        this.dataForm.province = defaultMsg.unitProvinceCity.split(",");
        this.dataForm.contact = defaultMsg.userName;
        this.dataForm.contactMobilePhone = Number(defaultMsg.phoneNumber);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.top-btn-box {
  .common-content-width();
  margin-bottom: 26px;
  margin-top: 30px;
  .floatl {
    display: block;
    line-height: 48px;
    color: @common-blue;
  }
}

.agreement-box {
  .common-content-width();
  .common-shadow();
  padding-bottom: 26px;
  margin-bottom: 50px;
}

/deep/.register-input-box {
  padding: 31px;
  margin-bottom: 50px;
  .common-shadow();
  .common-content-width();
  margin-bottom: 50px;
  .el-input {
    width: 176px;
  }
  .el-form-item__label {
    font-size: 14px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    color: #333;
  }
}

.dataform-input-box {
  line-height: 32px;
}

/deep/.goods-table {
  .common-content-width();
  margin-bottom: 50px;
  .common-shadow();
  tr th:first-child {
    padding-left: 20px !important;
  }
  tr td:first-child {
    padding-left: 20px !important;
    .cell {
      color: #666 !important;
    }
  }
  tr td:nth-last-child(3),
  tr td:nth-last-child(2) {
    .cell {
      color: @color-orange !important;
    }
  }
}

/deep/.sale-table {
  .common-shadow();
  .common-content-width();
  margin-bottom: 50px;
  tr th:first-child div {
    padding-left: 0 !important;
  }
  tr td:first-child div {
    padding-left: 0 !important;
  }
  .el-button {
    width: 64px;
    height: 24px;
    border-radius: 2px;
    border: solid 1px #999999;
    padding: 0;
    font-size: 14px;
    margin-right: 40px;
  }
}

.addressDetail {
  .el-input {
    width: 100%;
  }
}

.sale-table {
  background: #fff;
  padding: 30px;
}

.table-tip-link {
  color: @common-blue;
}

/deep/.sale-table-handle {
  color: @common-blue;
  margin-top: 20px;
  .el-input {
    width: 248px;
  }
  .el-input__inner {
    height: 32px;
  }
  .el-icon-info:before {
    margin: 0 10px 0 30px;
  }
}

.agreement-img {
  display: block;
  width: 150px;
  height: 200px;
  margin: 23px auto;
}

.agreement-btn {
  margin: 0 auto;
  display: block;
}

.sum-money-box {
  height: 60px;
  line-height: 60px;
  margin: 0 auto 60px;
  background: rgb(230, 230, 230);
  width: 96%;
  .sum-money {
    padding-left: 80%;
    .sum-red {
      color: #ff5f5f !important;
    }
  }
}
.span {
  float: left;
  color: #712105;
  background-color: bisque;
}
.span1 {
  float: left;
  font-weight: bolder;
  font-size: 15px;
}
.span2 {
  font-weight: 400;
  font-size: 13px;
}
.div001 {
  margin: 5px;
}
// /deep/.el-col-24{
//   width: 50%;
// }
.tton {
  margin: -7%;
  margin-left: 56%;
}
/deep/.el-dialog__body {
  padding: 15px 20px;
}
.contractNo {
  // width: 1005px;
  // margin-left: 10%;
  padding: 0px;
  .common-shadow();
  .common-content-width();
  margin-bottom: 0px;
  .el-form-item__label {
    font-size: 2px;
  }
}
.promotionCode{
  display: inline-block;
  overflow: hidden;
  width: 130px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderConfirm.vue